export const surgeonsConstants = {
  GETSURGEONS_REQUEST: 'GETSURGEONS_REQUEST2',
  GETSURGEONS_SUCCESS: 'GETSURGEONS_SUCCESS2',
  GETSURGEONS_FAILURE: 'GETSURGEONS_FAILURE2',
};
